function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
 * @copyright Copyright (c) 2021 Jonas Heinrich <onny@project-insanity.org>
 *
 * @author Jonas Heinrich <onny@project-insanity.org>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
import axios from '@nextcloud/axios';
import { generateUrl } from '@nextcloud/router';
var requesttoken = axios.defaults.headers.requesttoken;
export var RadioApi = /*#__PURE__*/function () {
  function RadioApi() {
    _classCallCheck(this, RadioApi);
  }

  _createClass(RadioApi, [{
    key: "url",
    value: function url(_url) {
      _url = "/apps/radio/api".concat(_url);
      return generateUrl(_url);
    }
  }, {
    key: "addFavorite",
    value: function addFavorite(station) {
      var stationSrc = '';

      if (!station.url_resolved) {
        stationSrc = station.urlresolved;
      } else {
        stationSrc = station.url_resolved;
      }

      station = {
        id: -1,
        name: station.name.toString(),
        urlresolved: stationSrc.toString(),
        favicon: station.favicon.toString(),
        stationuuid: station.stationuuid.toString(),
        bitrate: station.bitrate.toString(),
        country: station.country.toString(),
        language: station.language.toString(),
        homepage: station.homepage.toString(),
        codec: station.codec.toString(),
        tags: station.tags.toString()
      };
      axios.defaults.headers.requesttoken = requesttoken;
      return axios.post(this.url('/favorites'), station).then(function (response) {
        return Promise.resolve(response.data);
      }, function (err) {
        return Promise.reject(err);
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: "removeFavorite",
    value: function removeFavorite(station) {
      axios.defaults.headers.requesttoken = requesttoken;
      return axios.delete(this.url("/favorites/".concat(station.id))).then(function (response) {
        return Promise.resolve(response.data);
      }, function (err) {
        return Promise.reject(err);
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: "loadFavorites",
    value: function loadFavorites() {
      axios.defaults.headers.requesttoken = requesttoken;
      return axios.get(this.url('/favorites')).then(function (response) {
        return Promise.resolve(response.data);
      }, function (err) {
        return Promise.reject(err);
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: "addRecent",
    value: function addRecent(station) {
      var stationSrc = '';

      if (!station.url_resolved) {
        stationSrc = station.urlresolved;
      } else {
        stationSrc = station.url_resolved;
      }

      station = {
        id: -1,
        name: station.name.toString(),
        urlresolved: stationSrc.toString(),
        favicon: station.favicon.toString(),
        stationuuid: station.stationuuid.toString(),
        bitrate: station.bitrate.toString(),
        country: station.country.toString(),
        language: station.language.toString(),
        homepage: station.homepage.toString(),
        codec: station.codec.toString(),
        tags: station.tags.toString()
      };
      axios.defaults.headers.requesttoken = requesttoken;
      return axios.post(this.url('/recent'), station).then(function (response) {
        return Promise.resolve(response.data);
      }, function (err) {
        return Promise.reject(err);
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: "loadRecent",
    value: function loadRecent() {
      axios.defaults.headers.requesttoken = requesttoken;
      return axios.get(this.url('/recent')).then(function (response) {
        return Promise.resolve(response.data);
      }, function (err) {
        return Promise.reject(err);
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }]);

  return RadioApi;
}();